import React from 'react';
import Spacing from '../Spacing';
import SectionHeadingStyle3 from '../SectionHeading/SectionHeadingStyle3';
import AboutStyle4 from '../About/AboutStyle4';
import AboutStyle5 from '../About/AboutStyle5';
import IconBoxStyle6 from '../IconBox/IconBoxStyle6';
import SectionHeadingStyle5 from '../SectionHeading/SectionHeadingStyle5';
import SectionHeading from '../SectionHeading';
import TeamSlider from '../Slider/TeamSlider';
import { pageTitle } from '../../helpers/PageTitle';
const teamData = [
  {
    memberImg: '/images/studio-agency/team_1.jpeg',
    memberName: 'Olatunde Success',
    memberDesignation: 'CEO and Co-Founder',
    href: '/team/team-details',
  },
  {
    memberImg: '/images/studio-agency/team_2.jpeg',
    memberName: 'Adeoye Ayomide',
    memberDesignation: 'CTO and Co-Founder',
    href: '/team/team-details',
  },
  {
    memberImg: '/images/studio-agency/team_3.jpeg',
    memberName: 'Olatunde Wisdom',
    memberDesignation: 'COO and Co-Founder',
    href: '/team/team-details',
  },
];

export default function AboutPage({ darkMode }) {
  pageTitle('About');
  return (
    <>
      <Spacing lg="70" md="70" />
      <Spacing lg="140" md="80" />
      <SectionHeadingStyle3
        title="Delivering innovative technology solutions <br>that create business value"
        subTitle="About Us"
        variant="text-center"
        shape="shape_1"
      />
      <Spacing lg="75" md="60" />
      <AboutStyle4
        thumbnailSrc="/images/digital-agency/about_1.jpeg"
        miniTitle="Company Info"
        title="Technology solutions provider for modern businesses"
        subTitle="SAW Technologies specializes in building innovative software solutions that drive business growth. We combine deep technical expertise across web, mobile, and cloud development with modern DevOps and AI/ML capabilities to deliver comprehensive technology solutions that solve real-world challenges and create measurable value for our clients worldwide."
        btnText="See Our Services"
        btnUrl="/service"
      />
      {/* FunFact section hidden */}
      {/*
      <Spacing lg="125" md="70" />
      <div className="container">
        <FunFact data={funfactData} />
      </div>
      <Spacing lg="125" md="70" />
      */}
      <AboutStyle5
        variant="cs_type_1"
        thumbnailSrc="/images/digital-agency/about_2.jpeg"
        miniTitle="What We Do"
        title="Comprehensive technology solutions provider"
        subTitle="We specialize in custom software development, cloud infrastructure, AI/ML implementation, and technology consulting. Our team delivers scalable, secure, and innovative solutions that drive business growth and digital transformation."
        progressBarList={[
          { title: 'Software Development', percentage: '95' },
          { title: 'Cloud & DevOps', percentage: '90' },
          { title: 'AI/ML Solutions', percentage: '85' },
        ]}
        salesTitle="Project Success Rate"
        groth="98"
      />
      <Spacing lg="150" md="80" />
      <section className="cs_primary_bg">
        <Spacing lg="140" md="70" />
        <div className="container">
          <SectionHeadingStyle5 title="How we work" />
          <Spacing lg="85" md="45" />
          <div className="cs_working_process_wrap cs_center">
            <div className="cs_working_process">
              <div className="cs_working_process_col">
                <IconBoxStyle6
                  bgSrc="/images/others/process_1.png"
                  iconSrc="/images/icons/search.svg"
                  title="Discovery & Research"
                  subTitle="We begin by understanding your business needs, technical requirements, and goals. Through comprehensive research and analysis, we identify the optimal technology solutions."
                />
              </div>
              <div className="cs_working_process_col">
                <IconBoxStyle6
                  bgSrc="/images/others/process_2.png"
                  iconSrc="/images/icons/idea.svg"
                  title="Design & Architecture"
                  subTitle="Our team designs scalable, secure system architectures and creates detailed technical specifications. We ensure solutions are built on solid foundations for long-term success."
                />
              </div>
              <div className="cs_working_process_col">
                <IconBoxStyle6
                  bgSrc="/images/others/process_3.png"
                  iconSrc="/images/icons/gear.svg"
                  title="Development & Deploy"
                  subTitle="Using modern development practices, we build, test, and deploy your solution. Our DevOps approach ensures smooth delivery and ongoing optimization for maximum performance."
                />
              </div>
            </div>
          </div>
        </div>
        <Spacing lg="150" md="80" />
      </section>
      <section className="cs_p76_full_width">
        <Spacing lg="143" md="75" />
        <div className="container">
          <SectionHeading
            title="Meet our expert technology team <br />at SAW Technologies"
            subTitle="Our Team"
          />
          <Spacing lg="85" md="45" />
        </div>
        <TeamSlider data={teamData} />
      </section>
      {/* Brands section hidden */}
      {/*
      <Spacing lg="135" md="70" />
      <Marquee text="We Create Software - Build Platforms - Cloud Solutions - AI/ML - DevOps - SaaS Products" />
      <Spacing lg="84" md="50" />
      <div className="container">
        <Brands data={darkMode ? brandListDark : brandList} />
      </div>
      <Spacing lg="135" md="80" />
      */}
    </>
  );
}
